import { OmniElement, OmniStyleElement, html, css, nothing } from 'omni-ui';
import { OmniModal } from 'omni-ui/omni-modal.js';
import { setCookie, getCookie } from '../../helpers/utils.js';

OmniStyleElement.register();
OmniModal.register();

class CampaignVisibilityModal extends OmniElement {
  static get properties() {
    return {
      isVisibilityModalActive: { type: Boolean, state: true },
      activeModules: { type: Array },
      hiddenModules: { type: Object },
    };
  }

  static get styles() {
    return [
      super.styles,
      css`
        omni-modal::part(dialog) {
          --left: auto;
          --top: 10rem;

          right: 2rem;
          padding: 0;
          max-height: 60vh;
          max-width: 20rem;
          display: flex;
          flex-direction: column;
        }
        omni-modal::part(header) {
          margin: 0;
          padding: 0;
        }

        .modal-header {
          flex: 0 0 auto;
          height: 3.1428rem;
          padding: 0 0.86rem;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .modal-body {
          width: 100%;
          flex: 1 1 auto;
          display: flex;
          flex-direction: column;
          overflow-y: auto;
        }

        .module-list {
          display: flex;
          flex-direction: column;
          margin: 1.07rem;
        }
        .module-item {
          padding: 1.07rem;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          border: solid var(--color-transparent) 0.05rem;
          border: thin solid transparent;
          border-radius: 0.25rem;
        }
        .omni .module-item.module-item-hl {
          border-color: var(--color-primary);
        }
        .module-item,
        .module-item-hl {
          transition: all 0.5s ease;
        }

        .modal-explanation {
          white-space: normal;
          padding: 1.4rem 1.14rem 0 1.14rem;
        }
        .omni .button.reset.is-small {
          padding: 0.125rem 0.5rem;
        }

        .omni .label-button.button.is-small {
          padding: 0;
          justify-content: start;
        }
        .omni .label-button.button.is-small .subtitle {
          width: 100%;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: left;
          vertical-align: top;
          padding-bottom: 0.25rem;
        }
        .omni .label-button.button.is-small:hover,
        .omni .label-button.button.is-small:active,
        .omni .label-button.button.is-small:focus {
          background-color: var(--cover-transparent);
        }
        .omni .label-button.button.is-small::before {
          box-shadow: none;
        }
        .omni button.viz-button {
          align-items: flex-end;
        }
      `,
    ];
  }

  constructor() {
    super();
    this.isVisibilityModalActive = false;
    this.activeModules = [];
    this.hiddenModules = {};
    this.moduleClicked = '';
  }

  connectedCallback() {
    super.connectedCallback();

    if (getCookie('hiddenModules'))
      this.hiddenModules = JSON.parse(getCookie('hiddenModules'));
  }

  toggleModuleVisibility(uuidModule) {
    if (this.hiddenModules[this.activeStepId]?.[uuidModule]) {
      delete this.hiddenModules[this.activeStepId][uuidModule];
      if (Object.keys(this.hiddenModules[this.activeStepId]).length === 0)
        delete this.hiddenModules[this.activeStepId];
    } else {
      if (!this.hiddenModules[this.activeStepId])
        this.hiddenModules[this.activeStepId] = {};
      this.hiddenModules[this.activeStepId][uuidModule] = true;
    }
    this.dispatchNewEvent('module-visibility-changed', {
      detail: {
        uuidModule,
      },
    });

    setCookie('hiddenModules', JSON.stringify(this.hiddenModules));

    this.requestUpdate();
  }

  resetAll() {
    this.activeModules.forEach(moduleObj => {
      if (
        this.hiddenModules[this.activeStepId]?.[moduleObj.module.uuid_module]
      ) {
        this.toggleModuleVisibility(moduleObj.module.uuid_module);
      }
    });
  }

  handleModuleClick = uuidModule => {
    if (this.hiddenModules?.[this.activeStepId]?.[uuidModule]) return;

    this.moduleClicked = uuidModule;

    this.requestUpdate();

    setTimeout(() => {
      this.moduleClicked = '';
      this.requestUpdate();
    }, '1000');

    this.dispatchNewEvent('visibility-click', {
      detail: {
        moduleId: uuidModule,
      },
    });
  };

  handleModalVisibility = () => {
    this.isVisibilityModalActive = !this.isVisibilityModalActive;
  };

  get #modalTemplate() {
    return html`
      <omni-modal>
        <div slot="header" class="modal-header">
          <div class="is-size-4">Modules Visibility</div>
          <omni-tooltip slot="end">
            <button
              class="button is-text is-shadowless"
              slot="invoker"
              @click=${this.handleModalVisibility}
            >
              <omni-icon
                class="is-size-1"
                icon-id="omni:interactive:close"
              ></omni-icon>
            </button>
            <div slot="content">Close</div>
          </omni-tooltip>
        </div>
        <div class="modal-body">
          <div class="is-size-6 modal-explanation">
            <div>
              Select which modules are shown or hidden from the view. These
              settings are applied to your view only.
            </div>
            <div class="has-text-right">
              <button
                class="reset button is-text is-small"
                @click="${this.resetAll}"
              >
                Reset All
              </button>
            </div>
          </div>
          <div class="module-list">
            ${this.activeModules
              ?.sort((a, b) => a.display_order - b.display_order)
              .map(
                (moduleObj, index) => html`
                  <div
                    class="module-item ${this.moduleClicked ===
                    moduleObj.module.uuid_module
                      ? 'module-item-hl'
                      : ''}"
                  >
                    <button
                      class="label-button button is-text is-small"
                      @click=${() =>
                        this.handleModuleClick(moduleObj.module.uuid_module)}
                    >
                      <div class="subtitle">
                        ${index + 1}. ${moduleObj.module.name}
                      </div>
                    </button>
                    <omni-switch
                      .checked=${!this.hiddenModules?.[this.activeStepId]?.[
                        moduleObj.module.uuid_module
                      ]}
                      @change=${() =>
                        this.toggleModuleVisibility(
                          moduleObj.module.uuid_module,
                        )}
                    >
                      Hide
                      <p class="ml-2" slot="end">Show</p>
                    </omni-switch>
                  </div>
                `,
              )}
          </div>
        </div>
      </omni-modal>
    `;
  }

  get #buttonTemplate() {
    return html`
      <omni-tooltip slot="end">
        <button
          slot="invoker"
          class=" viz-button button is-text is-shadowless"
          @click=${this.handleModalVisibility}
          data-drawer-button
        >
          <omni-icon
            class="is-size-1"
            icon-id="omni:interactive:view"
          ></omni-icon>
        </button>
        <div slot="content">Modules Visibility</div>
      </omni-tooltip>
    `;
  }

  render() {
    return html`
      <omni-style>
        <div>${this.#buttonTemplate}</div>
        <div>
          ${this.isVisibilityModalActive ? this.#modalTemplate : nothing}
        </div>
      </omni-style>
    `;
  }
}

customElements.define('campaign-visibility-modal', CampaignVisibilityModal);
